/**
 * Defense Technology Intelligence
 *
 * Fuses the Publications/Research API with the PLA Contracts/Procurement API
 * into a single interactive, evidence-backed intelligence graph:
 * Organizations → Research → Technology → PLA → Procurement → Suppliers.
 *
 * Premium feature - requires Premium or Admin plan
 */
import { useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import { DefenseTechIntelligenceTemplate } from '../../components/templates/DefenseTechIntelligence';
import { PlanContext } from '../../Context/PlanContext';
import { Plan } from '../../shared/types';

export default function DefenseTechnologyIntelligencePage() {
  const plan = useContext(PlanContext);

  // Only Premium and Admin users can access this tool
  if (plan !== Plan.Premium && plan !== Plan.Admin) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ height: 'calc(100vh - 72px)', width: '100%' }}
      >
        <Typography variant="h5" gutterBottom>
          Premium Feature
        </Typography>
        <Typography color="textSecondary">
          Defense Technology Intelligence is only available to Premium users.
          Please upgrade your account to access this capability.
        </Typography>
      </Stack>
    );
  }

  return <DefenseTechIntelligenceTemplate />;
}
